import { NgModule } from '@angular/core';
import { CdsAccordionModule } from '@cds/angular/accordion';
import * as ɵngcc0 from '@angular/core';
export * from '@cds/angular/accordion';
import { CdsAlertModule } from '@cds/angular/alert';
export * from '@cds/angular/alert';
import { CdsBadgeModule } from '@cds/angular/badge';
export * from '@cds/angular/badge';
import { CdsBreadcrumbModule } from '@cds/angular/breadcrumb';
export * from '@cds/angular/breadcrumb';
import { CdsCardModule } from '@cds/angular/card';
export * from '@cds/angular/card';
import { CdsButtonModule } from '@cds/angular/button';
export * from '@cds/angular/button';
import { CdsDatalistModule } from '@cds/angular/datalist';
export * from '@cds/angular/datalist';
import { CdsCheckboxModule } from '@cds/angular/checkbox';
export * from '@cds/angular/checkbox';
import { CdsDateModule } from '@cds/angular/date';
export * from '@cds/angular/date';
import { CdsDividerModule } from '@cds/angular/divider';
export * from '@cds/angular/divider';
import { CdsFileModule } from '@cds/angular/file';
export * from '@cds/angular/file';
import { CdsFormsModule } from '@cds/angular/forms';
export * from '@cds/angular/forms';
import { CdsIconModule } from '@cds/angular/icon';
export * from '@cds/angular/icon';
import { CdsInputModule } from '@cds/angular/input';
export * from '@cds/angular/input';
import { CdsModalModule } from '@cds/angular/modal';
export * from '@cds/angular/modal';
import { CdsNavigationModule } from '@cds/angular/navigation';
export * from '@cds/angular/navigation';
import { CdsPaginationModule } from '@cds/angular/pagination';
export * from '@cds/angular/pagination';
import { CdsPasswordModule } from '@cds/angular/password';
export * from '@cds/angular/password';
import { CdsProgressCircleModule } from '@cds/angular/progress-circle';
export * from '@cds/angular/progress-circle';
import { CdsRadioModule } from '@cds/angular/radio';
export * from '@cds/angular/radio';
import { CdsRangeModule } from '@cds/angular/range';
export * from '@cds/angular/range';
import { CdsSearchModule } from '@cds/angular/search';
export * from '@cds/angular/search';
import { CdsSelectModule } from '@cds/angular/select';
export * from '@cds/angular/select';
import { CdsTagModule } from '@cds/angular/tag';
export * from '@cds/angular/tag';
import { CdsTestDropdownModule } from '@cds/angular/test-dropdown';
export * from '@cds/angular/test-dropdown';
import { CdsTextareaModule } from '@cds/angular/textarea';
export * from '@cds/angular/textarea';
import { CdsTimeModule } from '@cds/angular/time';
export * from '@cds/angular/time';
import { CdsToggleModule } from '@cds/angular/toggle';
export * from '@cds/angular/toggle';
import { CdsTreeViewModule } from '@cds/angular/tree-view';
export * from '@cds/angular/tree-view';
import { CdsInternalComponentsCloseButtonModule } from '@cds/angular/internal-components/close-button';
export * from '@cds/angular/internal-components/close-button';
import { CdsInternalComponentsOverlayModule } from '@cds/angular/internal-components/overlay';
export * from '@cds/angular/internal-components/overlay';
import { CdsInternalComponentsPanelModule } from '@cds/angular/internal-components/panel';
export * from '@cds/angular/internal-components/panel';
import { CdsInternalComponentsVisualCheckboxModule } from '@cds/angular/internal-components/visual-checkbox';
export * from '@cds/angular/internal-components/visual-checkbox';
import { CdsSelectionPanelsCheckboxModule } from '@cds/angular/selection-panels/checkbox';
export * from '@cds/angular/selection-panels/checkbox';
import { CdsSelectionPanelsRadioModule } from '@cds/angular/selection-panels/radio';
export * from '@cds/angular/selection-panels/radio';

/*
 * Copyright (c) 2016-2021 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
class CdsModule {
}
CdsModule.ɵfac = function CdsModule_Factory(t) { return new (t || CdsModule)(); };
CdsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: CdsModule });
CdsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CdsAccordionModule,
        CdsAlertModule,
        CdsBadgeModule,
        CdsBreadcrumbModule,
        CdsCardModule,
        CdsButtonModule,
        CdsDatalistModule,
        CdsCheckboxModule,
        CdsDateModule,
        CdsDividerModule,
        CdsFileModule,
        CdsFormsModule,
        CdsIconModule,
        CdsInputModule,
        CdsModalModule,
        CdsNavigationModule,
        CdsPaginationModule,
        CdsPasswordModule,
        CdsProgressCircleModule,
        CdsRadioModule,
        CdsRangeModule,
        CdsSearchModule,
        CdsSelectModule,
        CdsTagModule,
        CdsTestDropdownModule,
        CdsTextareaModule,
        CdsTimeModule,
        CdsToggleModule,
        CdsTreeViewModule,
        CdsInternalComponentsCloseButtonModule,
        CdsInternalComponentsOverlayModule,
        CdsInternalComponentsPanelModule,
        CdsInternalComponentsVisualCheckboxModule,
        CdsSelectionPanelsCheckboxModule,
        CdsSelectionPanelsRadioModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CdsModule, [{
        type: NgModule,
        args: [{
                exports: [
                    CdsAccordionModule,
                    CdsAlertModule,
                    CdsBadgeModule,
                    CdsBreadcrumbModule,
                    CdsCardModule,
                    CdsButtonModule,
                    CdsDatalistModule,
                    CdsCheckboxModule,
                    CdsDateModule,
                    CdsDividerModule,
                    CdsFileModule,
                    CdsFormsModule,
                    CdsIconModule,
                    CdsInputModule,
                    CdsModalModule,
                    CdsNavigationModule,
                    CdsPaginationModule,
                    CdsPasswordModule,
                    CdsProgressCircleModule,
                    CdsRadioModule,
                    CdsRangeModule,
                    CdsSearchModule,
                    CdsSelectModule,
                    CdsTagModule,
                    CdsTestDropdownModule,
                    CdsTextareaModule,
                    CdsTimeModule,
                    CdsToggleModule,
                    CdsTreeViewModule,
                    CdsInternalComponentsCloseButtonModule,
                    CdsInternalComponentsOverlayModule,
                    CdsInternalComponentsPanelModule,
                    CdsInternalComponentsVisualCheckboxModule,
                    CdsSelectionPanelsCheckboxModule,
                    CdsSelectionPanelsRadioModule,
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(CdsModule, { exports: function () { return [CdsAccordionModule,
        CdsAlertModule,
        CdsBadgeModule,
        CdsBreadcrumbModule,
        CdsCardModule,
        CdsButtonModule,
        CdsDatalistModule,
        CdsCheckboxModule,
        CdsDateModule,
        CdsDividerModule,
        CdsFileModule,
        CdsFormsModule,
        CdsIconModule,
        CdsInputModule,
        CdsModalModule,
        CdsNavigationModule,
        CdsPaginationModule,
        CdsPasswordModule,
        CdsProgressCircleModule,
        CdsRadioModule,
        CdsRangeModule,
        CdsSearchModule,
        CdsSelectModule,
        CdsTagModule,
        CdsTestDropdownModule,
        CdsTextareaModule,
        CdsTimeModule,
        CdsToggleModule,
        CdsTreeViewModule,
        CdsInternalComponentsCloseButtonModule,
        CdsInternalComponentsOverlayModule,
        CdsInternalComponentsPanelModule,
        CdsInternalComponentsVisualCheckboxModule,
        CdsSelectionPanelsCheckboxModule,
        CdsSelectionPanelsRadioModule]; } }); })();

/*
 * Copyright (c) 2016-2021 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CdsModule };

